<template>
    <label class="switch" :for="id">
        <input type="checkbox" :id="id" @input="$emit('input',$event.target.checked)" :checked="value">
        <span class="slider bar"></span>
    </label>
</template>

<script>
    import { uuid } from '../modules/helpers.js';
    export default {
        name: "StepIndicator",
        props: ['label', 'value'],
        data: () =>  {
            return {
                id: uuid(),
            }
        },
    }
</script>

<style scoped lang="scss">
    /* The switch - the box around the slider */
    .switch {
        /*transform: scale(0.75);*/
        position: relative;
        display: inline-block;
        width: 400px;
        height: 25px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $ss-grey2;
        -webkit-transition: 1s;
        transition: 1s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 23px;
        width: 200px;
        left: 1px;
        bottom: 1px;
        right: 1px;
        background-color: $primary;
        transition: 1s;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $primary;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(199px);
        -ms-transform: translateX(199px);
        transform: translateX(199px);
    }

</style>
